<template>
    <div class="testimonial-section bg-gray pt-100 pb-100">
        <div class="container">
            <!-- Section Title Start -->
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8 text-center">
                    <div class="sec-title">
                        <h2>Testimonials</h2>
                        <p>Consequuntur magni dolores eos qui ratione voluptatem </p>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
            <!-- Section Title End -->
            <div class="row">
                <div class="col-md-12">
                    <div class="all-testimonial">
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client1.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Andrew Nowrish</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client2.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Jessica Alba</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client3.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Will Smith</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client1.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Andrew Nowrish</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client2.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Jessica Alba</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>
                        <div class="client-wrapper">
                            <div class="client-inner">
                                <div class="client-img">
                                    <img src="images/client3.jpg" alt=""/>
                                </div>
                                <div class="client-info">
                                    <ul>
                                        <li class="name">Will Smith</li>
                                        <li class="position">Bank Mnager</li>
                                    </ul>
                                    <p>Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                                        numquam eius modi. </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Testimonials',
        components: {},
        data () {
            return {};
        },
        methods: {}
    };
</script>
